<template>
  <div class="invoice">
    <div class="invoice-wrap">
      <h5 class="header">补充订单所需发票信息</h5>
      <van-field label="检测项目" colon  :border="false" readonly label-width="5em" class="block">
        <template #input>
          <p v-for="item in infoData.item_list" :key="item.item_id">{{item.item_name}}</p>
        </template>
      </van-field>
      <van-field label="委托单位" colon v-model="infoData.sample_unit" :border="false" readonly label-width="5em"/>
      <van-field label="送检人" colon v-model="infoData.sample_contact_name" :border="false" readonly label-width="5em"/>
      <van-field label="地区" colon v-model="infoData.addr_detail" :border="false" readonly label-width="5em"/>
      <van-field label="送检样品信息" colon :border="false" readonly label-width="6.5em"/>
      <div class="sample_desc">{{infoData.sample_desc}}</div>
      <h6 class="tips-title">补充发票信息</h6>
      <van-radio-group v-model="invoiceForm.invoice_type" direction="horizontal" class="radio-box">
        <van-radio :name="1" icon-size="4.27vw">个人</van-radio>
        <van-radio :name="0" icon-size="4.27vw">公司</van-radio>
      </van-radio-group>
      <van-field name="radio" label="发票抬头" required colon label-width="5em">
        <template #input>
          <el-autocomplete
            clearable
            :debounce="500"
            value-key="invoice_title"
            placement="top"
            style="width: 100%"
            class="inline-input"
            :trigger-on-focus="false"
            v-model="invoiceForm.invoice_title"
            :fetch-suggestions="querySearch"
            placeholder="请输入内容"
            @select="handleSelect"
          ></el-autocomplete>
        </template>
      </van-field>
      <van-field name="radio" label="税号" v-if="invoiceForm.invoice_type === 0" v-model="invoiceForm.ein" required colon label-width="5em" placeholder="查询到抬头税号自动填充" />
      <van-field name="radio" label="手机号码" v-model="invoiceForm.mobile" :required="invoiceForm.invoice_type==1 ? true:false" colon label-width="5em" placeholder="输入手机号"/>
      <van-field name="radio" label="电子邮箱" v-model="invoiceForm.emaile" colon label-width="5em" placeholder="输入邮箱"/>
      <template v-if="invoiceForm.invoice_type === 0">
        <van-field name="radio" label="单位地址" v-model="invoiceForm.the_unit_address" colon label-width="5em" placeholder="输入地址"/>
        <van-field name="radio" label="开户行" v-model="invoiceForm.bank" colon label-width="5em" placeholder="输入开户行"/>
        <van-field name="radio" label="银行账户" v-model="invoiceForm.bank_id" colon label-width="5em" placeholder="输入银行账户"/>
      </template>
      <el-button type="text" @click="handleSubmit" :disabled="status">确认提交</el-button>
    </div>
  </div>
</template>
<script>
import { inoviceInfo, getInvoiceTitles, saveInvoice } from '@/api/resetApi.js'
import { Field, Toast } from 'vant';
export default {
  data(){
    return {
      infoData:{},
      status:false,
      invoiceForm:{
        invoice_title:'',
        invoice_type:1,
        mobile:'',
        emaile:'',
        ein:'',
        the_unit_address:'',
        bank:'',
        bank_id:''
      },
      list: [],
      order_id:''
    }
  },
  watch:{
    'invoiceForm.invoice_title':function(newVal){
      if(newVal){
        this.invoiceTitles()
      }
    }
  },
  mounted(){
    if(this.$route.query.id){
      this.order_id = this.$route.query.id
      this.info()
    }
  },
  methods:{
    // 名称
    handleSelect(item) {
      this.invoiceForm.ein = item.ein;
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.invoice_title.toLowerCase().indexOf(queryString.toLowerCase()) !==
          -1
        );
      };
    },
    // 名称
    querySearch(queryString, cb) {
      var restaurants = this.list;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      cb(results);
    },
    // 获取发票抬头
    async invoiceTitles(){
      try {
        const res = await getInvoiceTitles({
          invoice_title: this.invoiceForm.invoice_title
        })
        if(res.data.code === 1){
          this.list = res.data.data;
        }
      } catch (error) {

      }
    },
    // 获取发票详情
    async info(){
      try {
        const res = await inoviceInfo({order_id:this.order_id})
        if(res.data.code === 1){
          this.infoData = res.data.data || {}
        }
      } catch (error) {

      }
    },
    async rulesForm(type){
      const rePhone = /^1(3|4|5|6|7|8|9)\d{9}$/
      const reEmaile = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      const reBank = /^[0-9]\d{9,29}$/
      if(!this.invoiceForm.invoice_title){
        return Toast('请填写发票抬头')
      }else if(this.invoiceForm.emaile && !reEmaile.test(this.invoiceForm.emaile)){
        return Toast('请填写正确的邮箱地址')
      }else if(type === 1 && !this.invoiceForm.mobile){
        return Toast('请填写手机号')
      }else if(this.invoiceForm.mobile && !rePhone.test(this.invoiceForm.mobile)){
        return Toast('请输入正确格式的手机号')
      }else if(!this.invoiceForm.ein && type === 0){
        return Toast('请填写税号')
      }else if(this.invoiceForm.bank_id && reBank.test(this.invoiceForm.bank_id)){
        return Toast('请填写正确的银行账号')
      }else {
        try {
          const data = {
            order_id:this.order_id,
            invoice_info:this.invoiceForm
          }
          const res = await saveInvoice(data)
          if(res.data.code === 1){
            Toast.success('保存成功')
            this.status = true
          }

        } catch (error) {

        }
      }
    },
    // 提交
    handleSubmit(){
      this.rulesForm(this.invoiceForm.invoice_type)
    },
  }
}
</script>
<style lang="scss">
.invoice{
  .block{
    .van-field__control--custom{
      display: block;
    }
  }
  .van-field__label{
    margin-right: 0;
  }
  .el-input__inner{
    border: none;
    height: 24px;
    line-height: 24px;
    padding: 0;
  }
    padding: 5.33vw;
    margin: 0;
    font-size: 0;
    .invoice-wrap{
      border: 1px solid #ccc;
    }
    .header{
      padding:5.33vw 0;
      font-size:4.27vw;
    }
    .sample_desc{
      margin: 0 4.27vw;
      border: 1px solid #ccc;
      padding: 3.2vw;
      font-size: 3.2vw;
      text-align: left;
      line-height: 4.8vw;
    }
    .tips-title{
      font-size:3.2vw;
      color:#1890ff ;
      text-align: left;
      padding:2.67vw 0 4.27vw 4.27vw;
    }
    .radio-box{
      padding-left: 4.27vw;
      padding-bottom: 4.27vw;
      font-size: 3.2vw;
    }
}
</style>
